export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana2w.0310c9d4.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};